import { EventEmitter } from 'events';
import assign from 'object-assign';

import ApplicationDispatcher from '../../../dispatcher/ApplicationDispatcher.js';
import WorkspaceConstants from '../WorkspaceConstants.js';

var context = false;
var overlay = false;

var _userIsActive = true;
var _haltContext = false;

var _lastCreatedEvent = null;

var WorkspaceStore = assign({}, EventEmitter.prototype, {

    getState: function () {
        return {
            userIsActive: _userIsActive,
            haltContext: _haltContext,
        };
    },

    getLastCreatedEvent: function () {
        return _lastCreatedEvent
    },

    getContextMenuState: function () {
        return context;
    },

    getOverlayState: function () {
        return overlay;
    },

    emitChange: function () {
        this.emit('change');
    },

    addChangeListener: function (callback) {
        this.on('change', callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener('change', callback);
    },

    emitEventCreated: function () {
        this.emit('createdEvent');
    },

    addCreatedEventListener: function (callback) {
        this.on('createdEvent', callback);
    },

    removeCreatedEventListener: function (callback) {
        this.removeListener('createdEvent', callback);
    }
});

WorkspaceStore.dispatchToken = ApplicationDispatcher.register(function (payload) {

    var action = payload.action;
    var data = payload.action.data;

    switch (action.actionType) {
        case WorkspaceConstants.CONTEXT_TOGGLE:
            context = !context;
            WorkspaceStore.emitChange();
            break;

        case WorkspaceConstants.OVERLAY_TOGGLE:
            if (overlay !== data) {
                overlay = data;
                WorkspaceStore.emitChange();
            }
            break;

        case WorkspaceConstants.APPLICATION_HALT:
            _userIsActive = false;
            _haltContext = data;
            WorkspaceStore.emitChange();
            break;

        case WorkspaceConstants.APPLICATION_RESUME:
            _userIsActive = true;
            _haltContext = false;
            WorkspaceStore.emitChange();
            break;

        case WorkspaceConstants.TOGGLE_CREATED_EVENT_MODAL:
            _lastCreatedEvent = data.res;
            WorkspaceStore.emitEventCreated();
            break;
    }
})

export default WorkspaceStore;
